const _times=require('./_times')

module.exports=function defaultParametersFor(ABI) {
  console.log('here-defaultParametersFor',ABI)
  if (!ABI) {
    console.log("defaultParametersFor must have ABI")
    return []
  }
  var val = ABI.inputs.map((x,index) => {
    return module.exports.defForType(x.type,x.components)    
  })
  console.log('here-defaultParametersFor-ans',val)
  return val
}

module.exports.defForType=function defForType(x,components) {
  if (x.match(/\[.*\]/)) {
    // array array
    var { type, amount } = x.match(/^(?<type>.*)\[(?<amount>[0-9]*)\]$/).groups
    if (!amount) {
      amount = 0
    }
    return _times(amount, ()=>defForType(type,components))
  } 
  
  if (!x) {
    console.log("defaultParametersFor ABI must have type")
    return null
  
  } else if (x == "string") {
    return ""
  
  } else if (x == "tuple") {
    return  components.map(x=>defForType(x.type,x.components))

  } else if (x == "address") {
    return "0xaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa"
  
  } else if (x.match(/int/)) {
    return "0"
  }
  // if(x.match(/bytes[0-9]+/)) {
  //   var numOfBytes=parseInt(x.replace(/bytes/,''))
  //   return '0x' + '00'.repeat(numOfBytes)
  // }
  if(x.match(/bytes/)) {
    return '0x'
  }
}